<template>
    <div class="classroom-order-management">
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                流水导出
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="导出门店: ">
                    <el-select clearable v-model="dialog.content.storeId" placeholder="请选择导出门店" :disabled="$store.getters.getUserInfo.storeId != undefined">
                        <el-option v-for="item in storeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="导出类型: ">
                    <el-select clearable v-model="dialog.content.exportType" placeholder="请选择导出类型">
                        <el-option v-for="item in exportTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="起始时间: ">
                    <el-date-picker
                        v-model="dialog.content.startTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="请选择起始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间: ">
                    <el-date-picker
                        v-model="dialog.content.endTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="请选择结束时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>

        <div class="el-card-title">
            <span>数据筛选</span>
        </div>
        <div class="filter-row">
            <div class="filter-item">
                <span class="filter-title">订单状态： </span>
                <el-select clearable v-model="pageCfg.status" @change="filterChange" placeholder="请选择订单状态">
                    <el-option v-for="(item, i) in statusList" :key="i" :label="item.name" :value="item.value"></el-option>
                </el-select> 
            </div>
            <div class="filter-item">
                <span class="filter-title">订单创建时间： </span>
                <el-date-picker
                    v-model="dateTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="～"
                    @change="handleTimeChange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
        </div>

        <div class="el-card-title">
            <span>订单列表</span>
            <div :style="{ display: 'flex' }">
                <el-tooltip effect="dark" content="订单导出" placement="top">
                    <el-button type="text" @click="handleExport">
                        <i class="mdi mdi-24px mdi-export"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 640
        }">
            <template slot="operation" slot-scope="item">
                <el-button type="text" :disabled="item.data.row.status != 1" size="small" @click="rejectOrder(item.data.row)">退单</el-button>
            </template>
        </custom-table>
        <el-pagination
            :current-page="pageCfg.currentPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="pageCfg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.pageTotal"
            @current-change="handlePageChange"
            @size-change="handleSizeChange">
        </el-pagination>
        <!-- <el-card>
        </el-card> -->

    </div>
</template>

<script>
import { OrderManagementApi } from '../http/orderManagement/orderManagement'; 
// import { FileApi } from '../http/file';
import { CommonApi } from '../http/common';
import CustomTable from '../components/customTable.vue';
export default {
    name: "classroom-order-management",
    components: {
        CustomTable
    },
    data(){
        return {
            statusList: [
                {
                    name: "已支付",
                    value: 1
                },
                {
                    name: "已失效",
                    value: 2
                },
                {
                    name: "已超时",
                    value: 3
                },
                {
                    name: "已退款",
                    value: 4
                },
            ],
            exportTypeList: [
                {
                    name: "成功支付",
                    value: "1"
                },
                {
                    name: "退单",
                    value: "2"
                }
            ],
            storeList: [],
            pageCfg: {
                currentPage: 1,
                pageSize: 15,
                startTime: "",
                endTime: "",
                status: null,
                storeId: ""
            },
            tableData: {
                data: [],
                columns: [],
                tableLoading: false,
                pageTotal: 0
            },
            dateTime: [],
            dialog: {
                visible: false,
                title: "",
                content: {
                    storeId: "",
                    exportType: "",
                    startTime: "",
                    endTime: ""
                }
            }
        }
    },
    mounted(){
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.dialog.content.storeId = userInfo.storeId ? userInfo.storeId: "";
        this.pageCfg.storeId = userInfo.storeId ? userInfo.storeId: "";
        this.getOrderList();
        this.getStoreList();
    },
    methods: {
        getStoreList(){
            CommonApi.getStoreSelectorList().then(res => {
                this.storeList = res;
            })
        },
        getOrderList(){
            this.tableData.tableLoading = true;
            OrderManagementApi.getOrderList(this.pageCfg).then(res => {
                res.data.forEach(item => {
                    item.nickName = decodeURI(item.nickName);
                    item.price = "¥" + (parseInt(item.price) / 100).toFixed(2);
                });
                Object.assign(this.tableData, res);
                this.tableData.tableLoading = false;
            })
        },
        rejectOrder(item){
            this.$confirm('确定要退单吗?', '退单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                OrderManagementApi.rejectOrder(
                    {
                        platform: 'webapp',
                        classroomOrderId: item.classroomOrderId
                    }
                ).then(res => {
                    if(res.data.status === 200){
                        this.$notify.success({ title: '订单退订成功'});
                        this.getOrderList();
                    }
                })
            }).catch(() => {});
        },
        handlePageChange(page){
            this.pageCfg.currentPage = page;
            this.getOrderList();
        },
        handleSizeChange(size){
            this.pageCfg.pageSize = size;
            this.getOrderList();
        },
        filterChange(){
            this.pageCfg.currentPage = 1;
            this.getOrderList();
        },
        handleTimeChange(value){
            if(value){
                this.pageCfg.startTime = value[0];
                this.pageCfg.endTime = value[1];
            } else{
                this.pageCfg.startTime = "";
                this.pageCfg.endTime = "";
            }
            this.pageCfg.currentPage = 1;
            this.getOrderList();
        },
        handleCancel(){
            this.dialog.visible = false;
            for(let key in this.dialog.content){
                this.dialog.content[key] = "";
            }
        },
        handleExport(){
            this.dialog.visible = true;
            // this.dialog.title = "新增门店";
        },
        submit(){
            OrderManagementApi.exportOrder(this.dialog.content).then(res => {
                if(res){
                    var url = window.URL.createObjectURL(new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8'
                    }));
                    let a = document.createElement('a');
                    a.style.display = "none";
                    a.href = url;
                    a.click();
                    url = window.URL.revokeObjectURL(url);
                    document.body.removeChild(a)
                    this.$notify.success({title: "导出成功"});
                    this.handleCancel();
                } else{
                    this.$notify.warning({ title: res.data.message });
                }
            })
        }
    }
}
</script>

<style lang="less">
div.classroom-order-management{
    // padding: 14px 20px;
}
</style>